export default "__VITE_ASSET__oPOd4LE7__"